<template>
    <div>
        <b-row>
            <b-col>
                <h3 class="grey-color main_text font-weight-bold">История рейтинга</h3>
            </b-col>
            <b-col md="auto">
                <b-badge v-if="$store.state.organization.rating" class="mt-1 fs-18" variant="custom-green">
                    <b-icon-star-fill />
                    <span class="ml-2">{{ $store.state.organization.rating }}</span>
                </b-badge>
            </b-col>
        </b-row>

        <b-table :busy="isLoading" :fields="fields" :items="ratings" class="table-atmo" empty-text="Нет данных" show-empty>
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle mr-1"></b-spinner>
                    <strong>Загрузка данных...</strong>
                </div>
            </template>
            <template #cell(rate_date)="row">
                {{ $formatDate(row.item.rate_date) }}
            </template>
            <template #cell(purchasable_id)="row">
                <router-link class="atmo-button-link fw-400" :to="{ name: 'purchases.grouped.item.view', params: { group: 'fl44', id: row.item.purchasable_id } }" target="_blank">
                    {{ row.item.purchase_reg_number }}
                </router-link>
            </template>
            <template #cell(customer_id)="row">
                <router-link v-if="row.item.customer_id" class="atmo-button-link" :to="{ name: 'OrganizationShow', params: { id: row.item.customer_id } }" target="_blank">
                    {{ row.item.customer_name }}
                </router-link>
                <span v-else> Запись о рейтинге создана автоматически при заключении договора </span>
            </template>
            <template #cell(actions)="data">
                <action-button-small v-if="data.item.customer_id || data.item.comment" v-b-popover.hover.top="(data.detailsShowing ? 'Скрыть' : 'Показать') + ' подробности'" :icon="data.detailsShowing ? 'eye-slash' : 'eye'" @click="data.toggleDetails" />
            </template>
            <template #row-details="data">
                <p v-if="data.item.user_name"><b>Пользователь заказчика:</b> {{ data.item.user_name }}</p>
                <p v-if="data.item.comment"><b>Комментарий:</b> {{ data.item.comment }}</p>
            </template>
        </b-table>
    </div>
</template>

<script>
export default {
    name: 'RatingHistory',
    metaInfo: {
        title: 'История рейтинга'
    },
    data() {
        return {
            isLoading: true,
            ratings: [],
            fields: [
                { key: 'rate_date', label: 'Дата выставления оценки', thStyle: { width: '100px' }, tdClass: 'align-text-top py-1' },
                { key: 'rating', label: 'Оценка', thStyle: { width: '80px' }, tdClass: 'align-text-top py-1' },
                { key: 'purchasable_id', label: 'Рег.номер закупки', thStyle: { width: '150px' }, tdClass: 'align-text-top py-1' },
                { key: 'customer_id', label: 'Заказчик', tdClass: 'align-text-top py-1' },
                { key: 'actions', label: '', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap', thStyle: { width: '1px' } }
            ]
        };
    },
    async mounted() {
        if (!this.orgRoleIsPermitted(this.$orgRoles.SUPPLIER_FL44)) {
            await this.$router.replace({ name: '404' }).catch(() => {});
        } else {
            await this.getRatings();
            this.$scrollToTop();
        }
    },
    methods: {
        async getRatings() {
            this.isLoading = true;
            const response = await this.$api.cabinet.provider.ratingHistory.getList();
            this.ratings = response.data;
            this.isLoading = false;
        }
    }
};
</script>
